import React from 'react'
import { Menu, type MenuProps } from '@mantine/core'

export type AppMenuProps = MenuProps

function AppMenuRoot ({ shadow = 'md', withinPortal = true, ...props }: AppMenuProps) {
  return <Menu shadow={shadow} withinPortal={withinPortal} {...props} />
}

const AppMenu = Object.assign(AppMenuRoot, {
  Target: Menu.Target,
  Dropdown: Menu.Dropdown,
  Item: Menu.Item,
  Divider: Menu.Divider,
  Label: Menu.Label
})

export default AppMenu
